import Phaser from "phaser";
import Game from "./Scenes/Game";
import GameOver from "./Scenes/GameOverScreen";
import TitleScreen from "./Scenes/TitleScreen";

const config = {
  type: Phaser.AUTO,
  width: innerWidth,
  height: innerHeight,
  backgroundColor: "#11111b",

  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH
  },

  physics: {
    default: "arcade",
    arcade: {
      gravity: { y: 0 },
      debug: false
    },

  }
}


const game = new Phaser.Game(config)
game.scene.add('game', Game);
game.scene.add('game-over', GameOver);
game.scene.add('game-title', TitleScreen);

game.scene.start('game-title');
